module.exports = __webpack_public_path__ + "static/dbs-560e2f81345a71d1b9ec40f9c4e8a539.png";